import { useState, useEffect } from 'react';

import { getIntakeDeploymentOptions } from 'api/commitments';
import { fetchUserData } from 'api/user';
import { Deployments } from 'types';
import { MaybeUser } from 'util/user';

const useIntakeDeploymentOptions = (user: MaybeUser) => {
    const [intakeDeploymentOptions, setIntakeDeploymentOptions] = useState<Deployments[]>([]);
    const [isFetchingIntakeDeploymentOptions, setIsFetchingIntakeDeploymentOptions] = useState(true);
    const [fetchIntakeDeploymentOptionsError, setFetchIntakeDeploymentOptionsError] = useState(false);

    useEffect(() => {
        if (!user || !user.partner?.id) return;

        let cancelled = false;

        const fetchData = async () => {
            setIsFetchingIntakeDeploymentOptions(true);
            setFetchIntakeDeploymentOptionsError(false);
            try {
                const response = await fetchUserData(user.id);
                if (!response?.ok) {
                    throw new Error('Failed to fetch user');
                }

                const data = await response.json();
                if (cancelled) return;
                setIntakeDeploymentOptions(
                    getIntakeDeploymentOptions(data.user?.partner?.deployments)
                );
            } catch (error) {
                console.error('Error fetching intake deployment options:', error);
                setFetchIntakeDeploymentOptionsError(true);
            } finally {
                setIsFetchingIntakeDeploymentOptions(false);
            }
        };

        if (user.is_admin) {
            setIntakeDeploymentOptions(getIntakeDeploymentOptions(user.partner?.deployments));
            setIsFetchingIntakeDeploymentOptions(false);
            setFetchIntakeDeploymentOptionsError(false);
        } else {
            fetchData();
        } 

        return () => {
            cancelled = true;
        };
    }, [user]);

    return { intakeDeploymentOptions, isFetchingIntakeDeploymentOptions, fetchIntakeDeploymentOptionsError };
};

export default useIntakeDeploymentOptions;
